






















































































import Component from "vue-class-component";
import _ from "lodash";
import Http from "front-component/Http";
import StandardList from "front-component/components/List.vue";
import BudgetRepository from "@/repositories/socle/BudgetRepository";
import SocleAnabel from "./fields/Anabel.vue";
import SocleBudgetHierarchyFullName from "./fields/HierarchyFullName.vue";
import SocleBudgetIsValidated from "./fields/isValidated.vue";
import SocleBudgetLabel from "./fields/BudgetLabel.vue";
import SocleBudgetValidationDeadline from "./fields/ValidationDeadline.vue";
import SocleCampaignCode from "./fields/CampaignCode.vue";
import SocleCampaignLabel from "./fields/BudgetCampaignLabel.vue";
import SocleFormattedWeek from "./fields/FormattedWeek.vue";
import SocleSubHierarchy from "./fields/SubHierarchy.vue";
import SocleStoreStatus from "./fields/StoreStatus.vue";
import EventBus from "front-component/EventBus";
import {Prop, Watch} from "vue-property-decorator";
import {SocleClient} from "@/modules/Socle";

const components = {
    SocleAnabel,
    SocleBudgetIsValidated,
    SocleBudgetHierarchyFullName,
    SocleBudgetValidationDeadline,
    SocleCampaignCode,
    SocleCampaignLabel,
    SocleFormattedWeek,
    SocleSubHierarchy,
    SocleStoreStatus,
    SocleBudgetLabel,
};

@Component({ components })
export default class List extends StandardList {
    public loading: boolean = false;
    public elements: object[] = [];
    private selectedLines: any[] = [];
    private selectAll: boolean = false;
    public countBudgets: number = 0;
    public globalBudget: number = 0;

    @Prop() public configSocleData!: SocleClient;

    @Watch("filters") private cleanSelectedCampaign(): void {
        this.selectedLines = [];
        this.selectAll = false;
        this.retrieveAllFilteredBudget();
    }

    public created(): void {
        this.retrieveAllFilteredBudget();
        window.addEventListener("scroll", this.handleScroll);
        this.fields = Http.computeStandardFields(components, "budget");
        EventBus.$on("budget-status-updated", this.retrieveAllFilteredBudget);
        EventBus.$on("mass-budget-status-updated", this.handleMassCatalogStatusUpdated);
    }

    protected link() {
        return BudgetRepository.getSearchUrl();
    }

    private handleMassCatalogStatusUpdated() {
        this.selectedLines = [];
        this.countBudgets = 0;
        this.refreshList();
        this.retrieveAllFilteredBudget();
    }

    public isSelected(uuid: string): boolean {
        return _.some(this.selectedLines, (selected) => {
            return selected === uuid;
        });
    }

    public selectedAll(event: any): void {
        if (event.target.checked) {
            this.selectedLines = _.map(this.elements, "uuid");
        } else {
            this.selectedLines = [];
        }
    }

    private get budgetSelected() {
        return _.filter(this.elements, (budget: any) => {
            return this.isSelected(budget.uuid);
        });
    }

    public updateSelected(budget: any, event: any): void {
        if (event.target.checked) {
            this.selectedLines.push(budget.uuid);
        } else {
            this.selectedLines = _.filter(this.selectedLines, (selected) => {
                return selected !== budget.uuid;
            });
            this.selectAll = false;
        }
    }

    private retrieveAllFilteredBudget() {
        const params = { filters: this.filters};
        if (!this.filters) {
            return;
        }
        Http.get(
            "/countallsoclebudgettovalidate",
            params,
            (data: any) => {
                this.countBudgets = data[0].budgetCount;
                this.globalBudget = data[0].globalBudget;
                this.globalBudget += this.countBudgets * this.configSocleData.flatFeesAmount;
            },
            "errorLoadingCampaigns"
        );
    }

    public launchEdition(uuid: string) {
        this.$emit("show-operation", {uuid});
    }

    private launchValidationBudgetForm() {
        this.$emit("show-validation-budget", this.budgetSelected);
    }

    private launchAllValidationBudgetForm() {
        this.$emit("show-validation-budget", [], true, this.countBudgets, this.globalBudget);
    }

    private handleScroll() {
        const fadeElement: any = document.querySelector(".selectedBadge");
        if (window.scrollY > 0) {
            if (fadeElement) {
                fadeElement.style.display = "none";
            }
        } else {
            if (fadeElement) {
                fadeElement.style.display = "block";
            }
        }
    }

}
